import { FC, useContext, useState } from "react";
import Header from "../SubComponents/Header";
import { Formik, Form } from "formik";
import view from "../../assets/images/view.svg";
import unview from "../../assets/images/unview.svg";
import {
  Typography,
  Grid,
  Container,
  Box,
  useMediaQuery,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import Textfield from "../FormsUI/Textfield";
import ButtonSubmit from "../FormsUI/Button";
import { useTheme } from "@material-ui/core";
import AuthImage from "../SubComponents/AuthImage";
import imageauth from "../../assets/images/authimg.svg";
import newAuthImage from "../../assets/images/authbanner.png"
import useStyles from "../Styles/AuthStyles";
import PasswordStrengthIndicator from "../../helpers/PasswordStrengthIndicator";
import { ChangePasswordValidation } from "../../helpers/Validations";
import { useHistory, useParams } from "react-router";
import AuthContext from "../../store/Auth/AuthContext";

const INITIAL_FORM_STATE = {
  password: "",
  repassword: "",
};

const View = () => {
  return <img src={view} className="img-fluid" alt="Gains" />;
};
const Unview = () => {
  return <img src={unview} className="img-fluid " alt="Gains" />;
};

const ChangePassword: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActive1 = useMediaQuery(theme.breakpoints.down("xs"));
  const history = useHistory();

  let { token }: any = useParams();
  const { isAuth, recoverPassword } = useContext<any>(AuthContext);
  if (isAuth) {
    history.push("/deals");
  }

  const [password, setPassword] = useState({
    showPassword: false,
    showPassword2: false,
  });

  const handleClickShowPassword = () => {
    setPassword({ ...password, showPassword: !password.showPassword });
  };
  const handleClickShowPassword2 = () => {
    setPassword({ ...password, showPassword2: !password.showPassword2 });
  };

  const handleMouseDownPassword = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };

  const isNumberRegx = /\d/;
  const lowerUpperCase = /[A-Z]/;
  const isSpecialCharacter = /\W/;
  const [passwordFocused, setPasswordFocused] = useState(false);

  const [passwordValidity, setPasswordValidity] = useState({
    specialCharacter: false,
    minChar: false,
    number: false,
    lowerUpper: false,
    invalidText: false,
  });

  const onChangePassword = (password: { password: string }) => {
    setPasswordValidity({
      specialCharacter: isSpecialCharacter.test(password.password),
        minChar: password.password.length >= 8 && password.password.length <= 36 ? true :false,
        number: isNumberRegx.test(password.password) ? true : false,
        lowerUpper: lowerUpperCase.test(password.password) ? true : false,
        invalidText: password.password.toLowerCase().includes('gains') ? false : true,
    });
  };

  return (
    <Box className={classes.authpages} component="section">
      <Header authPage loginPage />
      <>
        <Container fixed>
          <Grid container spacing={0}>
            {!isActive && (
              <Grid className="borderleft" item md={5} sm={12}>
                <AuthImage image={newAuthImage} />
              </Grid>
            )}
            <Grid className="borderleft  borderRight" item md={7} sm={12}>
              <Box
                className="validateEmailTextBox"
                pl={isActive ? 0 : 7}
                pr={isActive ? 0 : 7}
              >
                <Typography variant="h2" color="primary">
                  Forgot
                  <Typography component="span" variant="h2" color="secondary">
                    {" "}
                    Password
                  </Typography>
                </Typography>
                {!isActive1 && (
                  <Box>
                    <Typography variant="body1">
                      Please note that when changing your password, we ask you
                      to <br /> set yourself a secure password.
                    </Typography>
                  </Box>
                )}

                <Box mt={isActive ? 3 : 3}>
                  <Formik
                    initialValues={{
                      ...INITIAL_FORM_STATE,
                    }}
                    validationSchema={ChangePasswordValidation}
                    validate={onChangePassword}
                    onSubmit={(values, { setSubmitting }) => {
                      setSubmitting(false);
                      if (
                        !passwordValidity.minChar ||
                        !passwordValidity.number ||
                        !passwordValidity.lowerUpper
                      ) {
                        return;
                      }
                      recoverPassword(values, token);
                    }}
                  >
                    {({ values, isSubmitting }) => (
                      <Form>
                        <Grid container spacing={isActive ? 2 : 3}>
                          <Grid item md={6} xs={12}>
                            <Typography
                              variant="subtitle1"
                              color="secondary"
                              className="fw-normal"
                            >
                              New Password*
                            </Typography>
                            <Textfield
                              name="password"
                              onFocus={() => setPasswordFocused(true)}
                              value={values.password}
                              type={password.showPassword ? "text" : "password"}
                              placeholder="Enter Password"
                              margin="dense"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                      color="secondary"
                                    >
                                      {password.showPassword ? (
                                        <Unview />
                                      ) : (
                                        <View />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Typography
                              variant="subtitle1"
                              color="secondary"
                              className="fw-normal"
                            >
                              Re-enter Password*
                            </Typography>
                            <Textfield
                              name="repassword"
                              type={
                                password.showPassword2 ? "text" : "password"
                              }
                              placeholder="Re - Enter Password"
                              margin="dense"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword2}
                                      onMouseDown={handleMouseDownPassword}
                                      edge="end"
                                      color="secondary"
                                    >
                                      {password.showPassword2 ? (
                                        <Unview />
                                      ) : (
                                        <View />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          {passwordFocused && (
                            <Grid item md={12} xs={12}>
                              <PasswordStrengthIndicator
                                validity={passwordValidity}
                              />
                            </Grid>
                          )}
                        </Grid>
                        <Box mt={3}>
                          <ButtonSubmit>Submit</ButtonSubmit>
                        </Box>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </>
    </Box>
  );
};

export default ChangePassword;
